import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

export class UploadFileForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            form: {
                file: undefined,
            },
            styles: {
                fileInputError: null
            }
        }
    }

    // -----------------

    onChangeFile(event, target) {
        const { form } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            form[target] = uploadedFile;

            this.setState({
                form: form
            });
        }
    }

    onSave() {
        if (this.validInput()) {
            const { form } = this.state;
            this.props.onSave(form.file);
        }
    }

    validInput() {
        let errors = 0;
        let fileInputError = null;

        const { form, styles } = this.state;

        if ("" === form.file || null === form.file || undefined === form.file || !form.file.name.endsWith(".png")) {
            fileInputError = 'error';
            errors++;
        }

        styles.fileInputError = fileInputError;

        this.setState({
            styles: styles
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { data, styles } = this.state;

        if (undefined === data || null === data) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Carregar Imagem</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={styles.fileInputError}>
                            <ControlLabel>Imagem</ControlLabel>
                            <FormControl
                                type="file"
                                placeholder="Ficheiro"
                                onChange={(e) => this.onChangeFile(e, "file")} />

                            {styles.fileInputError !== null ?
                                <HelpBlock> A Imagem é inválida </HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/settings/forms/UploadFileForm.js